import { GithubConnectionCard } from '@/components/account/github-connection-card'
import { NotionConnectionCard } from '@/components/account/notion-connection-card'
import { GoogleCalendarConnectionCard } from '@/components/account/google-calendar-connection-card'

// Brand-scoped content connections: read-only sources CASSI reads to notice what the brand
// shipped and turn it into posts. Distinct from social accounts (which we publish to).
export function ContentConnectionsPage() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="text-foreground text-xl font-semibold">Content connections</h2>
        <p className="text-muted-foreground text-sm">
          Sources CASSI reads to notice what you shipped or have coming up, and turn it into posts.
          Read-only, never posted to.
        </p>
      </div>
      <GithubConnectionCard />
      <NotionConnectionCard />
      <GoogleCalendarConnectionCard />
    </div>
  )
}
